import { SerializedData, Store } from "bernie-core";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { BexApiService } from "src/services/BexApiService";
import { action } from "mobx";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { CustomerSearchHistoryAllQuery, HistoryType } from "__generated__/api";
import { getBexApiContext } from "bernie-context";
import { BEX_API_FETCH_ERROR } from "src/config/systemEvents";

interface LobsSearchStatus {
  ACTIVITY_SEARCH?: boolean;
  ACTIVITY_DETAIL?: boolean;
  FLIGHT_SEARCH?: boolean;
  FLIGHT_DETAIL?: boolean;
  PACKAGE_SEARCH?: boolean;
  PROPERTY_SEARCH?: boolean;
  PROPERTY_DETAIL?: boolean;
}

export class RecentlyViewedStore extends Store {
  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, private bexApiService: BexApiService) {
    super(state, logger);
    this.bexApiService = bexApiService;
  }

  @action
  public async fetchRecentlyViewed(
    contextStore: ExtendedContextStore,
    numberOfResults: number,
    lobs: LobsSearchStatus
  ) {
    const recentSearchTypeArray: HistoryType[] = [];

    Object.keys(lobs).forEach((item) => lobs[item] && recentSearchTypeArray.push(item as HistoryType));

    const variables: CustomerSearchHistoryAllQuery.Variables = {
      context: getBexApiContext(contextStore),
      lobs: recentSearchTypeArray,
      numberOfResults,
    };
    try {
      const query = await this.bexApiService.fetchCustomerSearchAllHistoryQuery(variables);
      if (query.errors) {
        return [];
      }

      const searchResults = query.data.customer.searchHistory;

      return searchResults;
    } catch (err) {
      this.logger.logEvent(BEX_API_FETCH_ERROR, "Unexpected error when fetching recently viewed lobs", err);
      throw err;
    }
  }

  public hydrate(data: SerializedData): void {
    // The serialized store as returned by the server exposes a stripped down
    // version of bexApiService with no methods.We delete it here to prevent the override.
    delete data.bexApiService;

    Object.assign(this, data);
  }
}
